// Import Actions
import { SET_USERGROUPS, REMOVE_USERGROUP } from './UserGroupActions';

// Initial State
export const initialState = {
    data: [],
};

// Think to update reducers.js

const UserGroupReducer = (state = initialState, action) => {
    switch(action.type) {

        case SET_USERGROUPS:
            return {
                ...state,
                data: action.userGroups,
            };

        case REMOVE_USERGROUP:
            return {
                ...state,
                data: state.data.filter(userGroup => userGroup._id !== action.userGroupId),
            };

        default:
            return state;
    }
};

export default UserGroupReducer;
